import { Tooltip } from '@mui/material';
import { useMemo } from 'react';
import { SkillsTypeForDrivePositions } from 'types';

const CompanySkillsRequired = ({ skillsRequired }: { skillsRequired: SkillsTypeForDrivePositions[] }) => {
	const sortedSkillsRequired = useMemo(() => {
		return skillsRequired.sort((a, b) => a.name.length - b.name.length);
	}, [skillsRequired]);
	return (
		<>
			<div className="flex items-center justify-center text-center">
				<div>
					{sortedSkillsRequired.slice(0, 2).map((skill, index) => (
						<span key={index}>
							{skill.name}
							{index < 2 ? ', ' : ''}
						</span>
					))}
				</div>
			</div>
			{sortedSkillsRequired.length > 2 && (
				<Tooltip
					title={
						<div className="text-center">
							{skillsRequired

								.slice(2)
								.map((skill: SkillsTypeForDrivePositions) => skill.name)
								.join(', ')}
						</div>
					}
					arrow
					placement="bottom"
				>
					<div className="flex justify-center border-b border-[#555770] mx-auto border-dashed w-fit text-center mt-1 text-sm font-[500] text-[#555770]">
						more
					</div>
				</Tooltip>
			)}
		</>
	);
};

export default CompanySkillsRequired;
